import React from 'react'
import { Stack, Typography, useTheme } from '@mui/material'
import { getNumberRoundedInFormattedString } from '../../../utils/global-utils'

interface EventInvoiceInfoProps {
    costs: number | undefined
    revenue: number | undefined
    profit: number | undefined
}

const EventInvoiceInfo: React.FC<EventInvoiceInfoProps> = ({
    costs,
    revenue,
    profit,
}: EventInvoiceInfoProps) => {
    const theme = useTheme()
    return (
        <div
            style={{
                backgroundColor: theme.palette.background.default,
                padding: theme.spacing(3),
            }}
        >
            <Typography variant='h6' mb={3} color='primary'>
                Zisk
            </Typography>
            <Stack spacing={3}>
                <Stack direction='row' justifyContent='space-between' spacing={5}>
                    <Typography variant='body1'>Celkový náklady</Typography>
                    <Typography variant='body1'>{getNumberRoundedInFormattedString(costs ?? 0)}</Typography>
                </Stack>
                <Stack direction='row' justifyContent='space-between' spacing={5}>
                    <Typography variant='body1'>Celkový výnos</Typography>
                    <Typography variant='body1'>{getNumberRoundedInFormattedString(revenue ?? 0)}</Typography>
                </Stack>
                <Stack
                    direction='row'
                    justifyContent='space-between'
                    spacing={5}
                    padding={2}
                    bgcolor={theme.palette.tableHeader.default}
                >
                    <Typography variant='body1'>Zisk</Typography>
                    <Typography variant='body1'>{getNumberRoundedInFormattedString(profit ?? 0)}</Typography>
                </Stack>
            </Stack>
        </div>
    )
}

export default EventInvoiceInfo
